// extracted by mini-css-extract-plugin
export default {"price":"x5-z","onSale":"y5-z","msrpLabelPrice":"z5-z","msrpLabel":"A5-z","originalPrice":"B5-z","percentOff":"C5-z"};